import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PageNotFoundComponent } from 'src/app/shared/components/page-not-found/page-not-found.component';
import { AuthGuardService as AuthGuard } from 'src/app/guards/auth-guard.service';
import { AccountCreationResolver } from 'src/app/guards/account-creation.resolver';
import { UnsuccessfulLoginComponent } from 'src/app/shared/components/unsuccessful-login/unsuccessful-login.component';
import { ErrorTestComponent } from 'src/app/shared/components/error-test/error-test.component';
import { PasswordChangedComponent } from 'src/app/password-changed/password-changed.component';
import { ToolbarComponent } from 'src/app/toolbar/toolbar.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { CreateAccountComponent } from './create-account/create-account.component';
import { CreateAccountClosedComponent } from './create-account/create-account-closed.component';
import { ExpiredCreateAccountComponent } from './create-account/expired-create-account.component';
import { CallbackComponent } from './callback/callback.component';
import { ExportsComponent } from './exports/exports.component';
import { EulaGuardService as EulaGuard } from './guards/eula-guard.service';
import { MaintenanceModeComponent } from './maintenance-mode/maintenance-mode.component';
import { InactiveLinkComponent } from './shared/components/inactive-link/inactive-link.component';
import { ModuleGuardService } from './guards/module-guard.service';
import { TenantModuleType } from './shared/models/tenantModuleType';
import { SessionExpiredComponent } from './session-expired/session-expired.component';
import { PermissionDeniedComponent } from './shared/components/permission-denied/permission-denied.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: '',
    component: ToolbarComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent,
        data: { title: '${tenant} lineup', clearDynamicTitleState: true }
      },
      {
        path: 'exports',
        component: ExportsComponent
      },
      {
        path: 'teams',
        loadChildren: () => import('src/app/teams/teams.module').then((m) => m.TeamsModule),
        canLoad: [AuthGuard, EulaGuard]
      },
      {
        path: 'admin',
        loadChildren: () => import('src/app/admin/admin.module').then((m) => m.AdminModule),
        canLoad: [AuthGuard, EulaGuard],
        data: { roles: ['admin', 'owner', 'staff'] }
      },
      {
        path: 'people',
        loadChildren: () => import('src/app/people/people.module').then((m) => m.PeopleModule),
        canLoad: [AuthGuard, EulaGuard]
      },
      {
        path: 'credential-applications',
        loadChildren: () =>
          import('src/app/credentialing/credentialing-routing.module').then(
            (m) => m.CredentialingRoutingModule
          ),
        canLoad: [AuthGuard, EulaGuard],
        canActivate: [ModuleGuardService],
        data: { moduleType: TenantModuleType.Credentials }
      },
      {
        path: 'import-legacy',
        loadChildren: () => import('src/app/import/import.module').then((m) => m.ImportModule),
        canLoad: [AuthGuard]
      },
      {
        path: 'import',
        loadChildren: () =>
          import('src/app/import-beta/import-beta.module').then((m) => m.ImportBetaModule),
        canLoad: [AuthGuard]
      },
      {
        path: 'reports',
        loadChildren: () => import('src/app/reports/reports.module').then((m) => m.ReportsModule),
        canLoad: [AuthGuard, EulaGuard]
      },
      { path: 'test-browser-error', component: ErrorTestComponent },
      { path: 'passwordChangedCallback', component: PasswordChangedComponent }
    ]
  },
  { path: 'unsuccessful-login', component: UnsuccessfulLoginComponent },
  {
    path: 'create-account/expired',
    component: ExpiredCreateAccountComponent
  },
  {
    path: 'create-account/closed',
    component: CreateAccountClosedComponent
  },
  {
    path: 'create-account/:secureLinkId',
    component: CreateAccountComponent,
    resolve: { auth0User: AccountCreationResolver }
  },
  { path: 'callback', component: CallbackComponent },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'maintenance-mode', component: MaintenanceModeComponent },
  { path: 'session-expired', component: SessionExpiredComponent },
  {
    path: 'members',
    loadChildren: () => import('src/app/members/members.module').then((m) => m.MembersModule)
  },
  {
    path: 'opportunities',
    loadChildren: () =>
      import('src/app/public/opportunities/opportunities.module').then((m) => m.OpportunitiesModule)
  },
  { path: 'inactive-link', component: InactiveLinkComponent },
  { path: 'permission-denied', component: PermissionDeniedComponent, data: { showToolbar: true } },
  { path: '**', component: PageNotFoundComponent, data: { showToolbar: true } }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
